import { Component } from "@kluntje/core";

/**
 * Custom Element to add overlay logic to image
 */
class FRAImage extends Component {
  constructor() {
    super({
      ui: {
        image: ".fra-js-image__image",
        overlay: ".fra-js-overlay :-one",
      },
      events: [
        {
          event: "click",
          target: "image",
          handler: "handleClick",
        },
      ],
    });
  }

  /**
   * opens the clicked image inside an overlay
   * @param {Event} e
   */
  handleClick(e: Event): void {
    e.preventDefault();
    this.ui.overlay.open();
  }
}

customElements.define("fra-m-image", FRAImage);

export default FRAImage;
